import styled, { css } from 'styled-components';
export const Container = styled.div `
  ${({ fullWidth }) => css `
    display: flex;
    flex-direction: column;
    width: ${fullWidth ? '100%' : 'auto'};
  `}
`;
export const Label = styled.label `
  ${({ theme }) => css `
    color: ${theme.color.base.nth1};
    font-size: ${theme.font.size.xs};
    font-weight: ${theme.font.weight.semiBold};
    line-height: 21px;
    margin-bottom: 4px;
  `}
`;
export const customStyles = {
    option: () => ({
        marginLeft: 6,
        height: 20,
        fontSize: 12
    })
};
//# sourceMappingURL=SelectInput.styles.js.map